import { Directive, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';

@Directive()
export class AbstractPage implements OnDestroy {
  subs = new Subscription();

  ngOnDestroy(): void {
    console.log('Abstract Page - ngOnDestroy()');

    this.subs.unsubscribe();
  }
}
